// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"6c9431ea","353":"487f78cf","496":"671895c8","703":"caffc92e","850":"04df3dd5"}[chunkId] + ".chunk.js";
};